export default __webpack_public_path__ + "31e585d7061a3b1a1400393a0935e687.png";